export default __webpack_public_path__ + "static/media/contigocheco_abu_dhabi.961bf4cc.jpg";